import { Injectable } from '@angular/core';
import { Subject, Observable, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private eventBus: Subject<any> = new Subject<any>();

  publish(event: any): void {
    this.eventBus.next(event);
  }

  subscribe(eventName: string): Observable<any> {
    return this.eventBus.asObservable().pipe(
      filter((event: any) => event.name === eventName)
    );
  }
}